var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwnSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 124,
    viewBox: "0 0 248 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H224C237.255 0 248 10.7452 248 24V100C248 113.255 237.255 124 224 124H24C10.7452 124 0 113.255 0 100V24Z",
    fill: "#E7AF43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 28.9091C120 26.9008 121.628 25.2727 123.637 25.2727C125.645 25.2727 127.273 26.9008 127.273 28.9091V36.1818C127.273 38.1901 125.645 39.8182 123.637 39.8182C121.628 39.8182 120 38.1901 120 36.1818V28.9091ZM90.9093 58C88.901 58 87.2729 59.628 87.2729 61.6363C87.2729 63.6446 88.901 65.2727 90.9093 65.2727H98.182C100.19 65.2727 101.818 63.6446 101.818 61.6363C101.818 59.628 100.19 58 98.182 58H90.9093ZM149.091 58C147.083 58 145.455 59.628 145.455 61.6363C145.455 63.6446 147.083 65.2727 149.091 65.2727H156.364C158.372 65.2727 160 63.6446 160 61.6363C160 59.628 158.372 58 156.364 58H149.091Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M136.39 43.1684C134.97 44.5885 134.97 46.891 136.39 48.311C137.81 49.7311 140.112 49.7311 141.532 48.311L146.675 43.1684C148.095 41.7484 148.095 39.4459 146.675 38.0259C145.255 36.6058 142.952 36.6058 141.532 38.0259L136.39 43.1684Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.311 43.1684C111.731 44.5885 111.731 46.891 110.311 48.311C108.891 49.7311 106.589 49.7311 105.168 48.311L100.026 43.1684C98.6058 41.7484 98.6057 39.4459 100.026 38.0259C101.446 36.6058 103.748 36.6058 105.168 38.0259L110.311 43.1684Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M123.636 61.6364C121.628 61.6364 120 63.2644 120 65.2727V94.3636C120 96.3719 121.628 98 123.636 98C125.645 98 127.273 96.3719 127.273 94.3636V65.2727C127.273 63.2644 125.645 61.6364 123.636 61.6364Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.636 72.5455C129.661 72.5455 134.545 67.6613 134.545 61.6364C134.545 55.6115 129.661 50.7273 123.636 50.7273C117.611 50.7273 112.727 55.6115 112.727 61.6364C112.727 67.6613 117.611 72.5455 123.636 72.5455Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnSmall);
export default __webpack_public_path__ + "static/media/own-small.1b46c34d.svg";
export { ForwardRef as ReactComponent };